import { defineComponent as p, computed as E, provide as o, reactive as P, toRef as v, ref as O, createVNode as l, mergeProps as n, isVNode as T } from "vue";
import { ElDatePickerPanel as s } from "./index635.js";
import { datePickerProps as D } from "./index630.js";
import { ROOT_PICKER_IS_DEFAULT_FORMAT_INJECTION_KEY as b } from "./index632.js";
import { PICKER_POPPER_OPTIONS_INJECTION_KEY as A, DEFAULT_FORMATS_DATEPICKER as I, DEFAULT_FORMATS_DATE as R } from "./index579.js";
import C from "./index576.js";
import { UPDATE_MODEL_EVENT as i } from "./index584.js";
function N(r) {
  return typeof r == "function" || Object.prototype.toString.call(r) === "[object Object]" && !T(r);
}
var g = /* @__PURE__ */ p({
  name: "ElDatePicker",
  install: null,
  props: D,
  emits: [i],
  setup(r, {
    expose: d,
    emit: f,
    slots: a
  }) {
    const m = E(() => !r.format);
    o(b, m), o(A, P(v(r, "popperOptions")));
    const t = O();
    d({
      focus: () => {
        var e;
        (e = t.value) == null || e.focus();
      },
      blur: () => {
        var e;
        (e = t.value) == null || e.blur();
      },
      handleOpen: () => {
        var e;
        (e = t.value) == null || e.handleOpen();
      },
      handleClose: () => {
        var e;
        (e = t.value) == null || e.handleClose();
      }
    });
    const u = (e) => {
      f(i, e);
    };
    return () => {
      var e;
      const _ = (e = r.format) != null ? e : I[r.type] || R;
      return l(C, n(r, {
        format: _,
        type: r.type,
        ref: t,
        "onUpdate:modelValue": u
      }), {
        default: (c) => l(s, n({
          disabled: r.disabled,
          editable: r.editable,
          border: !1
        }, c), N(a) ? a : {
          default: () => [a]
        }),
        "range-separator": a["range-separator"]
      });
    };
  }
});
export {
  g as default
};
